export default __webpack_public_path__ + "images/b04d535d7d7db0e1f30401d61a995880.webp";